<template>
  <v-container v-if="product" class="p-product-detail pa-0">
    <v-layout class="pd-top block" wrap>
      <v-flex shrink class="mr-4">
        <img class="pd-top-img" :src="product.img">
      </v-flex>
      <v-flex class="pd-top-content">
        <v-layout justify-space-between column fill-height>
          <v-flex>
            <h1>{{ product.title }}</h1>
            <p class="subheading">{{ product.subheading }}</p>
          </v-flex>
          <v-flex shrink>
            <v-layout align-end justify-space-between wrap>
              <v-flex xs12 md7>
                <ul class="pl-0">
                  <li v-for="item in product.conditions" :key="item.title" class="mt-1">
                    <c-icon :name="item.icon"></c-icon>
                    <span>{{ item.title }}： {{item.content}}</span>
                  </li>
                </ul>
              </v-flex>

              <v-flex xs12 md5>
                <div class="mt-2 text-md-right">
                  <span
                    class="pd-top-company"
                    v-if="product.company.name"
                  >由{{ product.company.name }}承保并提供理赔服务</span>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout class="mt-3 mb-5">
      <v-flex>
        <!-- tabs -->
        <v-tabs
          v-model="tabActive"
          grow
          slider-color="primary"
          class="card-tabs"
        >
          <v-tab v-for="tab in productExtend.tabs" :key="tab" ripple>{{ tab }}</v-tab>

          <v-tab-item v-for="tab in productExtend.tabs" :key="tab">
            <component :is="tabComponents.get(tab)" :value="productExtend" :product="product"></component>
          </v-tab-item>
        </v-tabs>
      </v-flex>
      <v-flex class="operation-wrap" v-if="breakpoint.lgAndUp">
        <Operation :code="code"></Operation>
      </v-flex>
    </v-layout>
  </v-container>
  <v-layout justify-center v-else>loading</v-layout>
</template>

<script>
import Operation from "./components/Operation";
import Safeguards from "./components/Safeguards";
import Notices from "./components/Notices";
import Claims from "./components/Claims";
import Questions from "./components/Questions";

export default {
  beforeRouteEnter(to, from, next) {
    if (to.params.code === "1003") {
      window.location.href = "https://show.dhjyib.com/bbc/";
    } else {
      next();
    }
  },
  components: {
    Operation,
    Safeguards,
    Notices,
    Claims,
    Questions
  },
  props: {
    code: String
  },
  data() {
    return {
      tabActive: 0,
      tabComponents: new Map([
        ["保障介绍", "Safeguards"],
        ["投保须知", "Notices"],
        ["理赔流程", "Claims"],
        ["常见问题", "Questions"],
        ["理赔&发票流程", "Claims"],
      ])
    };
  },
  computed: {
    product() {
      return this.$store.getters.getProduct(this.code);
    },
    productExtend() {
      return this.$store.getters.getProductExtend(this.code);
    }
  },
  beforeCreate() {
    this.$store.dispatch("getProductExtends");
  }
};
</script>

<style lang="scss">
.p-product-detail {
  h1 {
    font-size: 1.75em;
    font-weight: 500;
  }
  h2 {
    font-size: 1.6em;
    font-weight: 500;
  }
  .subheading {
    font-size: 1.125em;
    color: #666666;
    margin-top: 0.9em;
  }
}
</style>
<style lang="scss" scoped>
.p-product-detail {
  h1 {
    font-size: 1.75em;
    font-weight: 500;
  }
  .subheading {
    font-size: 1.125em;
    color: #666666;
    margin-top: 0.9em;
  }
  .pd-top {
    padding-right: 1.5em;
    &-img {
      width: 300px;
      height: 220px;
    }
    &-company {
      font-size: 14px;
      color: #cccccc;
    }
  }
  .operation-wrap {
    width: 330px;
    flex: none;
    margin-left: 20px;
  }
  // 卡片 tabs
  .card-tabs {
    // 重写 light 为 UI设计稿
    .v-tabs__container {
      background-color: #efefef;
      .v-tabs__slider-wrapper {
        display: none;
      }
    }
  }
}
</style>






